import axios from 'axios';
import { MICR_URL } from '@/lib/constants/dashboard'

const instance = axios.create({
  baseURL: MICR_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

const _ = { instance, micrUrl: MICR_URL };

export function fetchBankInfoCtor(_) {
  const axiosInstance = _.instance;
  return async ({ institutionNumber, transitNumber }) => {
    try {
      const response = await axiosInstance({
        method: 'get',
        url: `/${institutionNumber}/${transitNumber}/`,
        withCredentials: false,
      });

      return {
        address: response.data.ad,
        institution: response.data.in,
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return {
          isUnknownBank: true,
        };
      }

      throw error;
    }
  }
}

export const fetchBankInfo = fetchBankInfoCtor(_);
